<template>
  <router-view />

  <cookie-banner/>
  <feedback-circle/>
</template>

<script>
import { mapActions } from "vuex";
import c from "@/store/consts";
import CookieBanner from "@/components/global-components/CookieBanner.vue";
import FeedbackCircle from "@/components/global-components/FeedbackCircle.vue";

export default {
  components: {FeedbackCircle, CookieBanner},
  created() {
    this[c.INIT_APP]();
  },

  methods: {
    ...mapActions([
      c.INIT_APP,
    ]),
  },
};
</script>

<style>
body {
  margin: 0;
  font-family: "Rubik", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.container {
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  gap: 15px;
  z-index: 0;
  overflow: hidden;
  max-width: 1200px;
  margin: 0 auto;
}

.surface {
  border-radius: 20px;
  -webkit-backdrop-filter: blur(18px);

  background:
      linear-gradient(
          180deg,
          rgba(80, 117, 153, 0.45),
          rgba(50, 97, 123, 0.55)
      );

  //background: linear-gradient(
  //    135deg,
  //    rgba(245, 250, 255, 0.32) 0%,
  //    rgba(220, 237, 250, 0.28) 50%,
  //    rgba(238, 247, 255, 0.32) 100%
  //);

  backdrop-filter: blur(18px);
  border: 1px solid rgba(255,255,255,.18);
  box-shadow:
      0 8px 32px rgba(80,120,180,.12),
      inset 0 1px 0 rgba(255,255,255,.22);

  width: 100%;
  color: #fff;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  padding: 30px;
}


.title {
  overflow: hidden;
  height: 50px;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  margin-top: 20px;
}

.title-tabs {
  display: flex;
  height: 50px;
  font-size: 20px;
}

.tab {
  position: relative;
  display: flex;
  flex-direction: row;
  flex: 1;

  align-items: center;
  justify-content: center;
  text-align: center;

  cursor: pointer;
  transition: color 0.3s ease;

  padding: 10px 0;
  opacity: 0.7;

  font-weight: 400;
  font-size: 20px;
}

.tab:hover,
.tab.active {
  opacity: 1;
}

.tab::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: white;
  transform: scaleY(0);
  transform-origin: bottom;
  transition: transform 0.3s ease;
}
.tab.active::after {
  transform: scaleY(1);
}


/* ------------------------- ПЛАНШЕТЫ ------------------------- */
@media screen and (max-width: 992px) and (orientation: landscape), screen and (min-width: 600px) and (max-width: 1200px) {
  .container {
    gap: 10px;
    max-width: 95vw;
  }

  .surface {
    border-radius: 15px;
    -webkit-backdrop-filter: blur(9px);
    backdrop-filter: blur(9px);

    padding: 20px;
  }


  /* ------------------------- ТАБЫ ------------------------- */
  .title-tabs {
    display: flex;
    flex-wrap: nowrap !important;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
    scrollbar-width: none;
    height: 60px;
  }

  .tab {
    font-size: 18px;
    padding: 10px 16px;
    min-width: fit-content;
  }

  .tab::after {
    height: 2px;
  }
}

  /* Мобилки */
@media (max-width: 600px) {
  .container {
    gap: 10px;
    max-width: 95vw;
  }

  .surface {
    border-radius: 15px;
    -webkit-backdrop-filter: blur(9px);
    backdrop-filter: blur(9px);

    padding: 20px;
  }

  /* ------------------------- ТАБЫ ------------------------- */
  .title-tabs {
    display: flex;
    flex-wrap: nowrap !important;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
    scrollbar-width: none;
    height: 50px;
  }

  .tab {
    font-size: 15px;
    padding: 10px 16px;
    min-width: fit-content;
  }

  .tab::after {
    height: 1px;
  }
}


</style>
